import AIRoadmapTable from "./ai-roadmap-table";
import { NavigationButton } from "../intro/objective";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const AIRoadmap = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.AI_ROADMAP}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/strategic-impact'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.STRATEGIC_IMPLICATIONS}</p></DisabledNavLink>
                    <DisabledNavLink to='/ai-usecase'><p className="m-0 p-0">{SECTION_NAMES.AI_USE_CASE_BOOKLET}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            <AIRoadmapTable />
            {/* <div style={{ textAlign: "center" }}>
                <button className="slick-arrow slick-prev slick-prev-page" to='/strategic-impact')}></button>
                <button className={`slick-arrow slick-next slick-next-page`} to='/ai-usecase')}></button>
            </div> */}
        </>
    );
};

export default AIRoadmap;
